import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 1399",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M1.07214 7.07199C1.07214 7.85992 1.22734 8.64014 1.52887 9.36809C1.8304 10.096 2.27235 10.7575 2.82951 11.3146C3.38666 11.8718 4.04809 12.3137 4.77605 12.6153C5.504 12.9168 6.28422 13.072 7.07215 13.072C7.86009 13.072 8.6403 12.9168 9.36826 12.6153C10.0962 12.3137 10.7576 11.8718 11.3148 11.3146C11.872 10.7575 12.3139 10.096 12.6154 9.36809C12.917 8.64014 13.0722 7.85992 13.0722 7.07199C13.0722 5.48069 12.44 3.95457 11.3148 2.82935C10.1896 1.70413 8.66346 1.07199 7.07215 1.07199C5.48085 1.07199 3.95473 1.70413 2.82951 2.82935C1.70429 3.95457 1.07214 5.48069 1.07214 7.07199Z",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M1.40027 4.99994H12.6003",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M1.40027 8.99988H12.6003",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M6.66714 0.999908C5.54403 2.79965 4.94861 4.87849 4.94861 6.99991C4.94861 9.12133 5.54403 11.2002 6.66714 12.9999",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M7.33386 0.999908C8.45697 2.79965 9.0524 4.87849 9.0524 6.99991C9.0524 9.12133 8.45697 11.2002 7.33386 12.9999",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgGlobe;
